<template lang="pug">
  div
    div(v-for='transform in transformsAndSource.transforms',class='h-full')
      inline-render(:transform='transform',
        class='h-full'
        :from='transformsAndSource.from',
        :gamedata='transformsAndSource.gamedata',
        :background-color='backgroundColor',
        :source='transformsAndSource.source')
      //toy
      //toy(:toy='toy',
        :tiledata='tiledata',
        label='label',
        style='width:96px; height:96px',
        :dropdownActive='false',
        :clickOnly='true',
        :dropdown='false',
        :bgcolor='bgcolor',
        @select='$emit("select", toy.id)')
</template>
<script>
import InlineRender from '@edit/atoms/InlineRender.vue';
export default {
  props:{
    transformsAndSource:{
      type:Object,
      required:true
    },
    backgroundColor:{
      type:String,
      default:'#000000'
    }
  },
  components:{
    InlineRender
  },
  data() {
    return {
    }
  },
  beforeDestroy() {
  },
  beforeCreate() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods:{
  },
  watch: {
  },
  computed: {
  }
}
</script>
<style>
</style>
